import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { IMAGES, ONLINE_WHATSAPP } from "@/lib/content";
import { Reveal } from "@/components/landing/Reveal";
import { EligibilityButton } from "@/components/landing/EligibilityButton";

export const OnlineFinalCTA = () => (
  <section
    className="relative overflow-hidden px-4 py-16 grid-bg sm:px-8 lg:py-28"
    id="online-inquire"
    data-testid="online-final-cta-section"
  >
    <div className="pointer-events-none absolute bottom-0 left-1/2 h-72 w-[42rem] -translate-x-1/2 rounded-full bg-em1/18 blur-[120px]" />
    <div className="relative z-10 mx-auto max-w-5xl">
      <Reveal className="mx-auto mb-12 max-w-4xl">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {[IMAGES.classroom1, IMAGES.classroom2].map((src, i) => (
            <motion.div
              key={i}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 260, damping: 20 }}
              className={`group relative overflow-hidden rounded-2xl border border-surfaceline glow-emerald ${
                i === 0 ? "sm:mt-6 sm:-rotate-1" : "sm:rotate-1"
              }`}
              data-testid={`online-session-photo-${i}`}
            >
              <img
                src={src}
                alt={`BullsEdge Academy live online batch session ${i + 1}`}
                style={{ objectPosition: i === 0 ? "50% 82%" : "50% 55%" }}
                className="h-72 w-full object-cover transition-transform duration-500 group-hover:scale-105 sm:h-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
              <span className="absolute bottom-3 left-3 rounded-full border border-em2/40 bg-ink/70 px-3 py-1 text-[0.7rem] font-semibold text-em2 backdrop-blur">
                Live online batch
              </span>
            </motion.div>
          ))}
        </div>
      </Reveal>

      <div className="mx-auto max-w-3xl text-center">
        <Reveal>
          <h2 className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-offwhite sm:text-6xl">
            Your Plan + 10 Planned Live Trades in 90 Days.
            <br />
            <span className="text-em2">First 2 Sessions Risk-Free.</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-mutedgreen sm:text-lg">
            Batches are kept small so every trade gets personal review. Tell us
            whether you're losing money or starting fresh, and we'll show you how
            the 90-day path fits you.
          </p>

          <div className="mx-auto mt-9 w-full max-w-md">
            <EligibilityButton
              size="lg"
              label="Reserve My Free Trial Seat"
              className="w-full"
              testId="online-final-cta"
            />
          </div>

          <div className="mt-4 flex justify-center">
            <a
              href={ONLINE_WHATSAPP}
              target="_blank"
              rel="noreferrer"
              data-testid="online-final-whatsapp-btn"
              className="inline-flex min-h-[48px] items-center gap-2 rounded-full border border-em2/40 bg-em2/10 px-6 text-sm font-semibold text-em2 transition-colors hover:bg-em2/20"
            >
              <MessageCircle size={16} /> Chat With Us on WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
